import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";


// views
import IndiceIQGFicha from "./IndiceIQGFicha";

// helpers
import { showMessage } from "../../../helpers/message.js";

// api
import indiceiqg_api from "../../../api/indiceiqg_api.js";
import usuario_api from "../../../api/usuario_api.js";

export default function IndiceIQGLista() {

  const [showLoading, setshowLoading] = useState(false);

  const [list_table, set_list_table] = useState([]);
  const [rowEdit, set_rowEdit] = useState(null);
  const [showDetail, set_showDetail] = useState(false);
  const [tipo, set_tipo] = useState(null);
  const [isDisable, set_isDisable] = useState(true);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    set_tipo(rowData.tipoIndice);
    setshowLoading(true);
    switch (rowData.tipoIndice) {
      case "Principal":
        indiceiqg_api.getIndiceIQG(rowData.id).then(result => showFicha(result));
        break;
      case "Sintético":
        indiceiqg_api.getIndiceSinteticoIQG(rowData.id).then(result => showFicha(result));
        break;
      case "Analítico":
        indiceiqg_api.getIndiceAnaliticoIQG(rowData.id).then(result => showFicha(result));
        break;
    }
  }
  const showFicha = (result) => {
    setshowLoading(false);
    if (result.status !== 200) {
      showMessage("Aviso", result.message, 'error', null);
    }
    else {
      set_rowEdit(result.data);
      set_showDetail(true);
    }
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_tipo(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setshowLoading(true);
    indiceiqg_api.getAll().then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    usuario_api.getFuncionalidadeAcaoLiberada("CadastroIndiceIQG", "Editar").then((result) => { set_isDisable(!result); });

    loadList();
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            {!isDisable && <Button color="default"
              onClick={handleAdd}
            >
              <i className="fa fa-plus"></i>  Novo Índice</Button>
            }
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Índices de IQG</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Tipo', field: 'tipoIndice' },
                      { title: 'Identificação', field: 'identificacao' },
                      { title: 'Fator Peso', field: 'fatorPeso' }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      ...table_style,
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <IndiceIQGFicha
          tipo={tipo}
          item={rowEdit}
          handleReturn={handleReturn}
        />
      }
    </>

  );
}